import Datapoint from 'owa-service/lib/contract/Datapoint';
import DatapointConsumer from 'owa-service/lib/contract/DatapointConsumer';
import logDatapointOperation from 'owa-service/lib/operation/logDatapointOperation';

export interface NewConsumerRecruitmentLogDataPointProps {
    firstName: string;
    userEmail: string;
    ageResponse: string;
    purposeResponse: string;
}

export function sendNewConsumerRecruitmentDatapoint(
    datapointProps: NewConsumerRecruitmentLogDataPointProps
): Promise<boolean> {
    const keys: string[] = ['ncrfn', 'ncrue', 'ncrar', 'ncrpr'];

    let values: string[] = [
        datapointProps.firstName,
        datapointProps.userEmail,
        datapointProps.ageResponse,
        datapointProps.purposeResponse,
    ];

    let newConsumerRecruitmentLogDatapoint: Datapoint = {
        Id: 'UVFeedback',
        Consumers: DatapointConsumer.Analytics,
        Time: new Date(Date.now()).toString(),
        Keys: keys,
        Values: values,
    };

    return logDatapointOperation({ datapoints: [newConsumerRecruitmentLogDatapoint] });
}
